import { type FormEvent, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  searchMails,
  type MailListItem,
  type PaginationMeta,
} from '../api/client';
import MailDetailView from '../components/MailDetail';
import MailList from '../components/MailList';

export default function SearchPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [from, setFrom] = useState('');
  const [subject, setSubject] = useState('');
  const [mailbox, setMailbox] = useState('');
  const [page, setPage] = useState(1);
  const [items, setItems] = useState<MailListItem[]>([]);
  const [pagination, setPagination] = useState<PaginationMeta | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  async function runSearch(nextPage = page) {
    setLoading(true);
    setError(null);
    setSearched(true);
    try {
      const data = await searchMails({
        page: nextPage,
        pageSize: 20,
        q: q || undefined,
        from: from || undefined,
        subject: subject || undefined,
        mailbox: mailbox || undefined,
      });
      setItems(data.items);
      setPagination(data.pagination);
      setPage(nextPage);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    void runSearch(1);
  }

  return (
    <div>
      <form className="toolbar" onSubmit={onSubmit}>
        <input
          className="input"
          style={{ flex: 1, minWidth: 200 }}
          placeholder="全文搜索（subject / from / mailbox，FTS）"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <input
          className="input"
          placeholder="mailbox"
          value={mailbox}
          onChange={(e) => setMailbox(e.target.value)}
        />
        <input
          className="input"
          placeholder="from"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
        />
        <input
          className="input"
          placeholder="subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <button type="submit" className="btn btn-primary" disabled={loading}>
          搜索
        </button>
      </form>

      {error && <div className="error-banner">{error}</div>}

      <div className="split">
        <div className="panel" style={{ display: 'flex', flexDirection: 'column' }}>
          {!searched ? (
            <div className="empty">输入关键词后搜索</div>
          ) : loading && !items.length ? (
            <div className="empty">搜索中…</div>
          ) : (
            <MailList items={items} activeId={id} basePath="/search/mail" />
          )}
          {pagination && (
            <div className="pagination">
              <button
                type="button"
                className="btn"
                disabled={page <= 1 || loading}
                onClick={() => void runSearch(page - 1)}
              >
                上一页
              </button>
              <span className="muted">
                {pagination.total} 条 · {page}/{pagination.totalPages}
              </span>
              <button
                type="button"
                className="btn"
                disabled={page >= pagination.totalPages || loading}
                onClick={() => void runSearch(page + 1)}
              >
                下一页
              </button>
            </div>
          )}
        </div>
        <MailDetailView
          mailId={id || null}
          onDeleted={() => {
            navigate('/search');
            void runSearch(page);
          }}
        />
      </div>
    </div>
  );
}
